import config from "utils/config";

module.exports = (function() {
    $.ajax({
        url: "/_form_params/",
        success: function(response) {
            const params = response.token ? response : JSON.parse(response);
            $("[name=_csrf_token]").val(params.token);
        },
    });

    if (config.get("zone")) return;

    $.ajax({
        url: "/_is_authed/",
        success: function(data) {
            if (data == "true") {
                $("#login-dropdown").html(
                    '<a href="/dashboard/" class="btn btn-sm btn-white"><span class="tapicon tapicon-user bold"></span> My account</a>',
                );
                $("#sidr .login").html(
                    '<a href="/dashboard/" class="spaced"><span class="tapicon tapicon-user"></span> My account</a>',
                );
            }
        },
    });
})();
